import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const GroupAndSocialSkillsProgramPageSession = React.lazy(() => import('../programs/groupandsocialskillsprogram/GroupAndSocialSkillsProgramPageSession'));
const GroupAndSocialSkillsProgramPageHeader = React.lazy(() => import('../programs/groupandsocialskillsprogram/GroupAndSocialSkillsProgramPageHeader'));

function GroupAndSocialSkillsProgramPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <GroupAndSocialSkillsProgramPageHeader />
       <GroupAndSocialSkillsProgramPageSession />
      </Suspense>
    </div>
  );
}

export default GroupAndSocialSkillsProgramPage;
